import { useIntl } from '@capsicum/common';
import { BorderedSection, Text } from '@capsicum/common-web';
import React from 'react';
import styled from 'styled-components';

type SignMessageModalProps = {
	message: string;
	origin?: string;
};

export const SignMessageModal = ({ message, origin }: SignMessageModalProps) => {
	const { $t } = useIntl();

	return (
		<>
			<S.Title variant="title6">{$t('ncWallet.walletConnect.signingModal.title')}</S.Title>
			<S.SecondaryText variant="text2">{origin}</S.SecondaryText>
			<S.StyledBorderedSection
				testID="wallet-connect-modal-signing-section"
				title={$t('ncWallet.walletConnect.signingModal.messageTitle')}
				titleInsideSection
			>
				<Text style={{ whiteSpace: 'pre-line' }} variant="text4">
					{message}
				</Text>
			</S.StyledBorderedSection>
		</>
	);
};

namespace S {
	export const Title = styled(Text)`
		display: block;
		text-align: center;
		margin-bottom: ${({ theme }) => theme.sizing.xxxsmall};
	`;
	export const SecondaryText = styled(Text)`
		color: ${({ theme }) => theme.colors.text.main.subtle};
		text-align: center;
		margin-bottom: ${({ theme }) => theme.sizing.medium};
	`;
	export const StyledBorderedSection = styled(BorderedSection)`
		margin-bottom: ${({ theme }) => theme.sizing.small};
		padding: ${({ theme }) => theme.spacings.medium};
	`;
}
